// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
// Pure key construction for the persistent (IndexedDB) raw-analysis cache.
// No browser APIs and no node:crypto, so it can be unit-tested directly under
// node. The key composes everything that must invalidate a cached analysis
// bundle: the analysis code version, the flight's content identity (source
// hash + normalized-artifact id + current analysis run), and the existing rawAnalysisSignature
// (aircraft, parser, entry id, review settings, context mode). Bump the cache
// namespace when detector parameters change without an ANALYSIS_VERSION bump.

// Control-character delimiter (U+0001): it cannot appear in sha256 hashes, ids,
// or the `|`-joined rawAnalysisSignature, so two different component layouts can
// never collapse to the same key (e.g. a hash ending in a value vs. a signature
// starting with it).
const FIELD_DELIMITER = String.fromCharCode(1);
// v16: separate-monitor twins with manual timing now score the cross-engine
// comparison instead of gating it.
export const RAW_ANALYSIS_CACHE_KEY_VERSION = "raw-analysis-cache/v16";

export function rawAnalysisCacheKey({
  analysisVersion,
  sourceHash,
  normalizedArtifactId,
  analysisRunId,
  signature,
} = {}) {
  return [
    "aca",
    RAW_ANALYSIS_CACHE_KEY_VERSION,
    analysisVersion ?? "",
    sourceHash ?? "",
    normalizedArtifactId ?? "",
    analysisRunId ?? "",
    signature ?? "",
  ].join(FIELD_DELIMITER);
}

export function rawAnalysisCacheFlightId(entry) {
  return entry?.database?.flightId ?? entry?.id ?? "";
}
